import { PATTERN_CPF } from './shared/constants';
import applyNumberMask from './shared/apply-number-mask';

export default function cpf(value) {
  const pattern = PATTERN_CPF;
  return applyNumberMask({ value, pattern });
}
